import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { ColorVariables } from "../Colors";

export const slideHeight = 100;
export const offsetPadding = (600 - slideHeight) / 2;

export const SwiperDiv = styled(Swiper)<{ $showQuote?: boolean }>`
  width: 330px;
  height: ${slideHeight}px;
  margin-top: ${offsetPadding}px;

  .swiper-pagination {
    height: 130px;
    margin-top: -110px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 10px;
    padding: 0;

    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      background: #2e2d29;
      &.swiper-pagination-bullet-active {
        background: #3b968b;
      }
    }
  }

  @media screen and (min-width: 951px) {
    width: 430px;
    .swiper-pagination {
      margin-top: -65px;
    }
  }

  .swiper-slide-prev {
    opacity: 0;
    transition: opacity 0.45s ease-out;
    z-index: -1;
  }
  .swiper-slide-next {
    opacity: 0 !important;
    z-index: -1;
  }
  .swiper-slide-active {
    transition: opacity 0.45s ease-in;
    transition-delay: 0.45s;
    z-index: 2;
    opacity: 1 !important;
  }
  .swiper-slide {
    opacity: 0;
  }
  overflow: visible;

  .carousel-swiper-slide {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 330px;
    height: ${(props) => (props.$showQuote ? "600px" : "425px")};
    position: relative;

    @media screen and (min-width: 951px) {
      width: 430px;
    }
    .banner {
      left: 60px;
      padding: 10px 20px;
      background: ${ColorVariables.sugar};
      border: 1px solid ${ColorVariables.coco1};
      box-shadow: 12px 12px 15px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      width: 330px;
      &__title {
        text-transform: uppercase;
      }
      &__top {
        position: absolute;
        top: 0;
        z-index: 1;
      }
      &__bottom {
        position: absolute;
        bottom: 0;
        z-index: 1;
      }
    }
    .imageAndBannerContainer {
      padding-top: 30px;
      padding-bottom: 30px;
      position: relative;
    }
    .imageContainer {
      position: relative;
      border: 1px solid ${ColorVariables.coco3};
      box-sizing: border-box;
      border-radius: 8px;
      height: 420px;
      width: 322px;
      overflow: hidden;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    }
    .quote {
      margin-top: 30px;
      font-weight: 380;
    }

    @media (max-width: 950px) {
      width: 330px;
      .banner {
        width: 300px;
        left: 30px;
      }
      .imageContainer {
        width: 260px;
        height: 340px;
      }
    }
  }
`;

export const SwiperSlideWrapper = styled.div`
  height: ${slideHeight}px;
  width: 100%;
`;

export const SwiperSlideChildWrapper = styled.div`
  height: 600px;
  width: 100%;
  margin-top: -${offsetPadding}px;
`;

export const SwiperSlideDiv = styled(SwiperSlide)``;
